const SUPPORTED_CROPS = new Set([
  'grain corn',
  'silage corn',
  'sunflower',
  'summer corn',
  'winter corn',
  'safra corn',
  'safrinha corn',
  'soy',
  'soybeans',
]);

export const isOsrSummarySupportedCrop = (cropName?: string): boolean => {
  const normalized = (cropName ?? '').toLowerCase();
  return SUPPORTED_CROPS.has(normalized);
};
